import React, { createContext, useContext, useEffect} from 'react'
import { DBGPhotoManager } from '../../../services/dbgPhotoManager'

const dbgPhotoManager = new DBGPhotoManager()

export const PhotoManagerContextClass = createContext(null)

export function PhotoManagerContext({
  children,
  setProgress, 
  setMessage
}) {
  
  useEffect(()=>{
    console.log('PhotoManagerContext | useEffect [setProgress, setMessage]')
  }, [setProgress, setMessage])

  return (
    <PhotoManagerContextClass.Provider value={{
      dbgPhotoManager
    }}>
        {children}
    </PhotoManagerContextClass.Provider>
  )
}

export function usePhotoManagerContext() {
  return useContext(PhotoManagerContextClass)
}


